import { render, staticRenderFns } from "./ICKEditor.vue?vue&type=template&id=a0afff22&"
import script from "./ICKEditor.vue?vue&type=script&lang=js&"
export * from "./ICKEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports